import { render, staticRenderFns } from "./BlocksTransactionsRowMobile.vue?vue&type=template&id=0bb85e10"
import script from "./BlocksTransactionsRowMobile.vue?vue&type=script&lang=js"
export * from "./BlocksTransactionsRowMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports